import React, { memo } from "react";
import workMetaData from '../../../utils/work.json';

export const Work = memo(() => {
  return (
    <div className="work-section">
      {
        workMetaData.work.map((work) => (
          <a href={work.url} key={work.id} target="_blank" rel="noopener noreferrer">
            <div className="work-card">
              <div className={`work-card-thumbnail card-thumbnail-${work.imageClass}`} />
              <div className="work-card-content flex flex-col">
                <h3 className="body-strong">{work.title}</h3>
                <div className="flex" style={{ gap: 'var(--scale-lg)', width: '100%', margin: 'var(--scale-es) 0' }}>
                  {
                    work.tags.map((tag) => (
                      <span className="work-card-tag label" key={tag}>{tag}</span>
                    ))
                  }
                </div>
              </div>
            </div>
          </a>
        ))
      }
    </div>
  );
});
